import usePrivateAxios from '@/common/api/usePrivateAxios'
import { useMutation } from '@tanstack/react-query'

interface UseMarkAllNotificationsAsRead {
  onSuccess?: () => void
  onError?: (error: any) => void
}

export const useMarkAllNotificationsAsRead = ({ onSuccess, onError }: UseMarkAllNotificationsAsRead) => {
  const privateAxios = usePrivateAxios()
  return useMutation({
    mutationKey: ['markNotificationAsRead'],
    mutationFn: async () => {
      await privateAxios.put('/notifications/recipient_messages/mark_all_as_read', {})
    },
    onSuccess,
    onError,
  })
}